import { Component, OnInit, ViewChild } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import {
    TransportCompanyTableActionComponent
} from './transport-company-table-action/transport-company-table-action.component';
import { SttTableComponent } from '../../../../shared/components/stt-table/stt-table.component';
import { SttTableService } from '../../../../shared/components/stt-table/stt-table-service';
import { TransportCompanyModel } from '../../../../shared/entities/transport-company.model';
import { TransportCompanyAddEditComponent } from './transport-company-add-edit/transport-company-add-edit.component';
import { TransportCompanyService } from '../../../../shared/services/app/transport-company.service';
import { TransportUnitsComponent } from '../transport-units/transport-units.component';

@Component({
    selector: 'app-transport-company',
    templateUrl: './transport-company.component.html',
    styleUrls: ['./transport-company.component.scss']
})
export class TransportCompanyComponent implements OnInit {

    @ViewChild('table', { static: false }) table: SttTableComponent;

    public tableEndpoint = 'transport-companies';
    public tableActionComponent = TransportCompanyTableActionComponent;
    public expandComponent = TransportUnitsComponent;
    public tableQuery: any;
    public ref: DynamicDialogRef;

    constructor(private transportCompanyService: TransportCompanyService, public dialogService: DialogService) {
        this.tableQuery = new SttTableService().addInclude('city').addInclude('county').addInclude('type');
    }

    ngOnInit(): void {

    }

    addNewEntity() {
        this.ref = this.dialogService.open(TransportCompanyAddEditComponent, {
            header: 'Adaugare companie de transport',
            width: '70%',
            contentStyle: { 'max-height': '70vh' },
            baseZIndex: 10000,
            closeOnEscape: false,
            data: null,
        });

        this.ref.onClose.subscribe((transportCompany: TransportCompanyModel) => {
            if (transportCompany) {
                this.table.refresh();
            }
        });
    }

}
